export default __webpack_public_path__ + "static/media/scenerary_icon.6986f132.svg";